import fetchLoyaltyConfig from 'actions/loyalty/fetchLoyaltyConfig'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

function useLoyaltyConfig(): [App.LoyaltyConfig | undefined, boolean, any] {
  const dispatch = useAppDispatch()

  const config = useAppSelector(state => state.loyalty.config)
  const fetching = useAppSelector(state => state.loyalty.fetchingConfig)
  const error = useAppSelector(state => state.loyalty.configError)
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)

  // Re-run on region change so config is refetched for the new region. Also depends on the
  // loaded config's region: if a fetch resolves for a region that's no longer the current one
  // (e.g. region switched mid-flight), this re-fires and fetches the current region's config.
  useEffect(() => {
    dispatch(fetchLoyaltyConfig())
  }, [dispatch, currentRegionCode, config?.region])

  return [
    config,
    !!fetching,
    error,
  ]
}

export default useLoyaltyConfig
